module.exports = __webpack_public_path__ + "static/media/03.eb3bc30f.png";